<template>
  <div>
    <section class="bg-white py-8 border-b-2 border-gray-300">
      <div class="w-full md:w-10/12 mx-auto flex justify-between">
        <div class="flex w-full flex-col justify-center items-start">
          <div class="flex items-center">
            <div class="flex-1">
              <img class="rounded-full h-20 mr-6" :src="$store.getters.tokenInfo.picture" />
            </div>
            <div class="flex-1">
              <h2 class="font-bold text-2xl">{{ $store.state.loggedInUser.name }}</h2>
              <h3 class="text-xl text-gray-600 mr-5">{{ $store.state.loggedInUser.email }}</h3>
            </div>
          </div>
          <router-link
            to="/"
            class="flex items-center mt-8 bg-white hover:bg-white -ml-2 py-2 pl-3 pr-4 text-gray-900 font-semibold border hover:border-gray-400 border-white rounded hover:shadow"
          >
            <svg class="fill-current mr-2 h-5 w-5" viewBox="0 0 24 24">
              <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
            </svg>
            <span class="uppercase text-sm">Back to home</span>
          </router-link>
        </div>
      </div>
    </section>

    <section class="py-8">
      <div class="w-full md:w-10/12 mx-auto flex flex-col">
        <div
          v-if="isDisabled"
          class="border-l-4 border-blue-500 bg-blue-100 text-blue-800 py-5 mb-5 rounded pl-4"
        >You cannot change your details as you logged in with a Social Provider. In order to change these details you must change then with the provider.</div>

        <h2 class="text-2xl font-semibold mb-5">Profile</h2>

        <div class="rounded shadow bg-white p-8 flex flex-col">
          <div class="flex">
            <div class="flex-1 mr-3">
              <label
                class="inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3"
                for="name"
              >Name</label>
              <input
                class="appearance-none block w-full disabled:bg-gray-200 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:cursor-not-allowed"
                id="name"
                v-model="name"
                type="text"
                :disabled="isDisabled"
              />
            </div>
            <div class="flex-1 ml-3">
              <label
                class="inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3"
                for="email"
              >Email</label>
              <input
                class="appearance-none block w-full disabled:bg-gray-200 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:cursor-not-allowed"
                id="email"
                v-model="email"
                type="text"
                disabled
              />
            </div>
          </div>
          <div class="flex flex-row-reverse mt-8">
            <button
              @click="saveProfile"
              :disabled="isDisabled || buttonLoading"
              class="bg-green-200 hover:bg-green-300 text-green-900 font-semibold border border-green-400 rounded hover:shadow disabled:bg-green-500 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <div v-if="!buttonLoading" class="inline-flex items-center py-2 px-4">
                <svg class="fill-current h-5 2-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"
                  />
                </svg>
                <span>Save</span>
              </div>
              <div v-if="buttonLoading" class="inline-flex items-center py-2 px-10 text-white">
                <span class="mdi mdi-loading mdi-spin"></span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
</style>

<script>
import axios from "axios";

export default {
  name: "profile",
  mounted() {
    if (this.$store.getters.loginMethod == "google-oauth2") {
      this.isDisabled = true;
    }
    console.log(this.$store.getters.loginMethod);
    this.name = this.$store.state.loggedInUser.name;
    this.email = this.$store.state.loggedInUser.email;
  },
  methods: {
    async saveProfile() {
      this.buttonLoading = true;
      try {
        await axios.put("/api/user-profile", {
          name: this.name
        });
        this.$store.dispatch("getUserProfile");
        this.buttonLoading = false;
        // this.$buefy.notification.open({
        //   message: "Your profile has been successfully updated.",
        //   type: "is-success",
        //   duration: 5000
        // });
      } catch (error) {
        console.error(error);
        this.buttonLoading = false;
      }
    }
  },
  data() {
    return {
      isCancelModelActive: false,
      isDisabled: false,
      name: "",
      email: "",
      buttonLoading: false
    };
  }
};
</script>

